import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Spacer } from 'ascential-horizon'
import getThemeConfig from '../providers/config/themeConfig'
import { getTalentHero } from '../services/hero'
import Layout from '../Layout'
import Breadcrumbs from '../components/Breadcrumbs'
import Hero from '../components/Hero'
import Talent from '../components/Talent'

const TemplateTalentsPage = ({ data, pageContext, location }) => {
  const { showBreadcrumbs } = getThemeConfig()
  const {
    home: { header, footer, banner },
  } = data
  const {
    speakers,
    pageTitle,
    pageType,
    breadcrumb: { crumbs },
  } = pageContext

  const layoutProps = {
    header: {
      ...header,
      banner,
    },
    footer,
    pageType,
    pageContext,
    location,
  }

  const talentHero = getTalentHero()

  const heroProps = {
    headlineImage: talentHero.heroHeadlineImage,
    image: talentHero.heroImage,
    title: talentHero.title || '',
    mobileImage: talentHero.mobileImage || null,
    subtitle: talentHero.subtitle || null,
    variant: talentHero.variant || 'standard',
    textColor: talentHero.textColor || 'standard',
    ctaLabel: null,
  }

  const breadcrumbProps = {
    crumbs,
    crumbLabel: pageTitle,
    location,
  }

  return (
    <Layout {...layoutProps}>
      {showBreadcrumbs && <Breadcrumbs {...breadcrumbProps} />}
      <Hero {...heroProps} />
      <Spacer>
        <Talent speakers={speakers} />
      </Spacer>
    </Layout>
  )
}

TemplateTalentsPage.propTypes = {
  pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export const templateTalentsPageQuery = graphql`
  query($rootId: String!) {
    home: contentfulTemplateHomePage(id: { eq: $rootId }) {
      ...header
      footer {
        ...footerQuery
      }
      banner {
        ...bannerQuery
      }
    }
  }
`

export default TemplateTalentsPage
